import {calculateFlatKpr} from './simulasi-kpr-calculation';

jQuery(function () {
  document.querySelectorAll('.simulasi-kpr').forEach(section => {
    const form = section.querySelector('form');
    const field = name => form.elements.namedItem(name);
    const number = name => Number(field(name).value.replace(',', '.'));
    const integer = name => Number(field(name).value.replace(/\D/g, ''));
    const format = value => Math.round(value).toLocaleString('id-ID');
    const money = value => 'Rp ' + format(value);
    const output = (name, value) => { section.querySelector('[data-result="' + name + '"]').textContent = value; };
    const minDp = Number(section.dataset.minDp);
    let depositSource = 'dp-percent';

    function formatCurrencyInput(input) {
      const original = input.value;
      const digitsBeforeCaret = original.slice(0, input.selectionStart).replace(/\D/g, '').length;
      const formatted = format(integer(input.name));
      if (original === formatted) return;

      input.value = formatted;
      let caret = 0;
      let digits = 0;
      while (caret < formatted.length && digits < digitsBeforeCaret) {
        if (/\d/.test(formatted[caret])) digits++;
        caret++;
      }
      // Keep the existing zero placeholder behavior when the field is cleared.
      if (original === '') caret = formatted.length;
      input.setSelectionRange(caret, caret);
    }

    function syncDeposit(source) {
      const price = integer('price');
      if (source === 'dp-amount') {
        field('dp-percent').value = price > 0 ? String(Math.round(integer('dp-amount') / price * 10000) / 100).replace('.', ',') : '0';
      } else {
        field('dp-amount').value = format(price * number('dp-percent') / 100);
      }
    }

    function updateTenor() {
      const slider = field('tenor');
      const value = Number(slider.value);
      const span = Number(slider.max) - Number(slider.min);
      const progress = span > 0 ? (value - Number(slider.min)) / span * 100 : 0;
      section.style.setProperty('--kpr-progress', progress + '%');
      section.querySelector('.kpr-tenor-value').textContent = value + ' Tahun';
      field('fixed-years').max = value;
      if (Number(field('fixed-years').value) > value) field('fixed-years').value = value;
    }

    form.addEventListener('input', event => {
      const name = event.target.name;
      event.target.setCustomValidity('');
      if (name === 'price' || name === 'dp-amount') formatCurrencyInput(event.target);
      if (name === 'dp-amount' || name === 'dp-percent') depositSource = name;
      if (['price', 'dp-amount', 'dp-percent'].includes(name)) syncDeposit(depositSource);
      if (name === 'tenor') updateTenor();
      section.querySelector('.kpr-error').textContent = '';
    });

    function calculate(event) {
      if (event) event.preventDefault();
      const price = integer('price');
      const deposit = integer('dp-amount');
      const percent = price > 0 ? deposit / price * 100 : 0;
      const rate = Number(field('rate').value);
      const years = Number(field('tenor').value);
      const fixed = Number(field('fixed-years').value);
      if (!form.checkValidity()) { form.reportValidity(); return; }
      if (price <= 0 || deposit > price || percent + 0.000001 < minDp || !Number.isFinite(number('dp-percent')) || fixed < 1 || fixed > years) {
        section.querySelector('.kpr-error').textContent = 'Periksa harga unit, DP minimal ' + minDp + '%, dan masa bunga fix (maksimal sesuai tenor).';
        return;
      }
      try {
        const result = calculateFlatKpr(price, deposit, rate, years);
        const percentText = String(Math.round(percent * 100) / 100).replace('.', ',');
        output('upfront', money(result.upfront));
        output('monthly', money(result.monthly));
        output('upfront-note', 'DP ' + percentText + '% + estimasi biaya ' + money(result.fees));
        output('monthly-note', 'Per bulan; bunga fix selama ' + fixed + ' tahun');
        output('monthly-note-mobile', 'Per bulan selama ' + years + ' tahun');
        output('dp', percentText + '% dari harga unit');
        output('fees', '± ' + money(result.fees));
        output('rate', String(rate).replace('.', ',') + '% / tahun (flat)');
        output('tenor', years + ' tahun');
        section.querySelector('.kpr-error').textContent = '';
      } catch (error) {
        section.querySelector('.kpr-error').textContent = 'Periksa kembali nilai yang dimasukkan.';
      }
    }
    form.addEventListener('submit', calculate);
    field('price').value = format(integer('price'));
    syncDeposit('dp-percent');
    updateTenor();
    calculate();
  });
});



// WEBPACK FOOTER //
// ./scripts/page-template/page-builder/simulasi-kpr.js